export const HAKLAI_DEPRECIATION_LABELS = Object.freeze({
  title: "פחת",
  customBuildingPercent: "אחר",
  exemptRentalTaxTrack: "פטור",
  rentalIncomeTaxTrack: "10%",
  rentalIncomeTaxTrackTitle: "מסלול מיסוי ההכנסה משכירות",
  buildingPercent: "שיעור חלק המבנה",
  customPercent: "שיעור מותאם",
  depreciationRate: "שיעור פחת",
  rentedFromDate: "הושכר מתאריך",
  untilDate: "עד תאריך",
  calculatedDepreciation: "פחת מחושב",
  depreciationAmount: "סכום הפחת לניכוי",
  residentialRentalDepreciation: "פחת דירת מגורים",
  form11Depreciation: "פחת לפי טופס י\"א",
  rentedQuestion: "האם הושכר?",
  yes: "כן",
  no: "לא"
});

export const HAKLAI_DEPRECIATION_ACTIONS = Object.freeze({
  configure: "הגדר",
  check: "בדוק",
  enterForm11: "הזן י\"א",
  edit: "ערוך",
  deleteData: "מחיקת נתונים",
  save: "שמור",
  delete: "מחק",
  cancel: "ביטול"
});

export const HAKLAI_DEPRECIATION_TOOLTIPS = Object.freeze({
  addRange: "הוספה",
  deleteRange: "מחיקה",
  rentalNotRelevant: "פחת לא רלוונטי לרכיב זה",
  removeRentalDepreciation: "בחר לא כדי להסיר את פרטי הפחת בשכירות",
  enterRentalDepreciation: "בחר כן כדי להזין פרטי פחת בשכירות",
  mustMarkRentedBeforeEdit: "יש לבחור כן לפני עריכת הפרטים",
  rentalDepreciationNeedsReview: "יש לבדוק את פרטי הפחת בשכירות",
  editRentalDepreciation: "עריכת פרטי פחת בשכירות"
});

export const HAKLAI_DEPRECIATION_ERRORS = Object.freeze({
  missingSoldDate: "יש להזין תחילה את תאריך המכירה",
  missingPurchaseDetails: "יש להשלים פרטי רכישה לפני הזנת פחת",
  missingAcquisitionAmount: "יש להשלים את עלות הרכישה של הרכיב",
  missingSaleValue: "יש להזין קודם את שווי החלק בטבלת מרכיבי הנכס",
  missingBuiltValue: "יש להזין תחילה את שווי החלק הבנוי בטבלה",
  builtValueExceedsSale: "שווי החלק הבנוי לא יכול להיות גדול משווי החלק",
  depreciationAmountInvalid: "יש להזין סכום פחת תקין",
  missingRentalRange: "יש להזין לפחות תקופת השכרה אחת",
  startDateRequired: "תאריך התחלה הינו שדה חובה",
  endDateRequired: "תאריך סיום הינו שדה חובה",
  endDateFuture: "תאריך סיום לא יכול להיות תאריך עתידי",
  startDateAfterEndDate: "תאריך התחלה לא יכול להיות לאחר תאריך סיום",
  startDateBeforePurchase: "תקופת ההשכרה מתחילה לפני תאריך הרכישה הרלוונטי",
  endDateAfterSale: "תאריך הסיום לא יכול להיות לאחר תאריך המכירה",
  dateRangesOverlap: "טווחי התאריכים צריכים להיות לפי סדר ובלי חפיפה ביניהם",
  taxTrackRequired: "יש לבחור מסלול מיסוי",
  buildingPercentInvalid: "יש להזין שיעור חלק מבנה תקין",
  purchaseDepreciationConflict: "יש לבחור מסלול פחת אחד לרכישה",
  startDateInvalid: "תאריך התחלה אינו תקין",
  endDateInvalid: "תאריך סיום אינו תקין"
});

export const HAKLAI_DEPRECIATION_DIALOG = Object.freeze({
  clearTitle: "למחוק את כל נתוני הפחת?",
  clearText: "הפעולה תמחק את נתוני הפחת שהוגדרו עבור פריט זה.",
  clearRentalTitle: "האם להסיר את הסימון שהדירה הושכרה?",
  clearRentalText: "הפעולה תמחק את ניכויי הפחת שהוזנו עבור רכיב זה.",
  manualForm11Notice: "נא למלא סכום פחת רק עבור רכיבים בני פחת, בהתאם לטופס י\"א מרו\"ח"
});

export const getHaklaiDepreciationDialogTitle = (label = "") => {
  const normalizedLabel = String(label || "").trim();
  return normalizedLabel
    ? `${HAKLAI_DEPRECIATION_LABELS.title} - ${normalizedLabel}`
    : HAKLAI_DEPRECIATION_LABELS.title;
};
